import { ChevronDownIcon, ChevronUpIcon, MinusCircleIcon } from '@heroicons/react/solid';
import { useEffect, useState } from 'react';
import { fetchClinics } from '../providers/clinics';
import { useTranslations } from '../providers/i18n';
import { Select } from './Field';

function ManageFeaturedClinics(props) {
    const [t, translationsLoaded] = useTranslations('manage-featured-clinics');
    const [ready, setReady] = useState(false);
    const [clinics, setClinics] = useState([]);
    const [available, setAvailable] = useState([]);
    const [selected, setSelected] = useState([]);

    const removeHandler = (index) => {
        setSelected((oldValue) => {
            const newValue = [...oldValue];
            newValue.splice(index, 1);
            return newValue;
        });
    };

    const selectHandler = (e) => {
        const { id, name } = clinics.find(({ id }) => id == e.target.value);
        setSelected((oldValue) => [...oldValue, { id, name }]);
    };

    const swapSelected = (a, b) => {
        setSelected((oldValue) => {
            const newValue = [...oldValue];
            const temp = newValue[a];
            newValue[a] = newValue[b];
            newValue[b] = temp;
            return newValue;
        });
    };

    useEffect(() => {
        fetchClinics().then((clinics) => {
            setClinics(clinics);
            setReady(true);
        });
    }, []);

    useEffect(() => {
        setSelected(clinics.filter(({ featured }) => featured).sort((a, b) => a.featured - b.featured));
        setAvailable(clinics.filter(({ featured }) => !featured));
    }, [clinics]);

    useEffect(() => {
        const selectedIds = selected.map(({ id }) => id);
        setAvailable(clinics.filter(({ id }) => !selectedIds.includes(id)));
    }, [selected]);

    if (!ready) return null;
    if (!translationsLoaded) return null;

    return (
        <div className="space-y-2">
            {selected.length ? (
                <div className="overflow-hidden rounded-md border border-gray-300 shadow-sm">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th colSpan="2" className="px-4 py-2 text-left font-medium">
                                    {t('featured-clinics')}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y bg-white">
                            {selected.map(({ id, name }, index) => (
                                <tr key={index}>
                                    <td className="w-0 py-2 pl-4">
                                        <div className="flex gap-1">
                                            <button
                                                type="button"
                                                className={`text-gray-500 hover:text-gray-800 ${index == 0 ? 'opacity-0' : ''}`}
                                                onClick={() => {
                                                    swapSelected(index, index - 1);
                                                }}
                                            >
                                                <ChevronUpIcon className="relative top-[1px] h-5 w-5" />
                                            </button>

                                            <button
                                                type="button"
                                                className={`text-gray-500 hover:text-gray-800 ${index == selected.length - 1 ? 'opacity-0' : ''}`}
                                                onClick={() => {
                                                    swapSelected(index, index + 1);
                                                }}
                                            >
                                                <ChevronDownIcon className="relative top-[1px] h-5 w-5" />
                                            </button>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2">{name}</td>
                                    <td className="w-0 text-right text-xs">
                                        <input type="hidden" name="clinics[]" value={id} />
                                        <button
                                            type="button"
                                            className="px-4 text-gray-500 hover:text-gray-800"
                                            onClick={() => {
                                                removeHandler(index);
                                            }}
                                        >
                                            <MinusCircleIcon className="relative top-[1px] h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <input type="hidden" name="clinics[]" />
                    <div className="mb-4 rounded-md border-2 border-dashed border-gray-300 py-10 text-center text-gray-500">{t('no-clinics')}</div>
                </>
            )}

            <div className="w-72">
                <Select placeholder={t('add-clinic') + '...'} options={available} onChange={selectHandler} />
            </div>
        </div>
    );
}

export default ManageFeaturedClinics;
